import React from 'react';
import styled from 'styled-components';
import { FilePdfOutlined, FileImageOutlined, FileWordOutlined, FileOutlined, CloseOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "uploading-file-itemcomponent__Container",
  componentId: "sc-b0f2r6-0"
})(["display:flex;align-items:center;gap:12px;padding:12px;background:#ffffff;border:1px solid #f0f2f7;border-radius:12px;box-shadow:0 1px 2px rgba(15,23,42,0.04);&:hover{border-color:#e0e4ef;}"]);
var IconWrapper = styled.div.withConfig({
  displayName: "uploading-file-itemcomponent__IconWrapper",
  componentId: "sc-b0f2r6-1"
})(["display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;flex-shrink:0;", ""], function (_ref) {
  var $variant = _ref.$variant;

  switch ($variant) {
    case 'pdf':
      return "\n          background: #fef2f2;\n          color: #ef4444;\n        ";

    case 'image':
      return "\n          background: #eff6ff;\n          color: #3b82f6;\n        ";

    case 'doc':
      return "\n          background: #eef2ff;\n          color: #4f46e5;\n        ";

    default:
      return "\n          background: #f1f5f9;\n          color: #64748b;\n        ";
  }
});
var FileInfo = styled.div.withConfig({
  displayName: "uploading-file-itemcomponent__FileInfo",
  componentId: "sc-b0f2r6-2"
})(["flex:1;display:flex;flex-direction:column;gap:2px;min-width:0;"]);
var FileName = styled.div.withConfig({
  displayName: "uploading-file-itemcomponent__FileName",
  componentId: "sc-b0f2r6-3"
})(["font-size:14px;color:#1a2140;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
var FileMeta = styled.div.withConfig({
  displayName: "uploading-file-itemcomponent__FileMeta",
  componentId: "sc-b0f2r6-4"
})(["font-size:12px;color:#8b95b0;"]);
var RemoveButton = styled.button.withConfig({
  displayName: "uploading-file-itemcomponent__RemoveButton",
  componentId: "sc-b0f2r6-5"
})(["display:flex;align-items:center;justify-content:center;width:28px;height:28px;border:none;background:transparent;color:#9aa4c2;cursor:pointer;border-radius:6px;transition:all 0.2s;flex-shrink:0;&:hover{color:#ef4444;background:#fef2f2;}"]);

var getVariantFromMime = function getVariantFromMime(type) {
  if (!type) {
    return 'default';
  }

  if (type === 'application/pdf') return 'pdf';
  if (type.startsWith('image/')) return 'image';

  if (type === 'application/msword' || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return 'doc';
  }

  return 'default';
};

var getIconFromVariant = function getIconFromVariant(variant) {
  switch (variant) {
    case 'pdf':
      return /*#__PURE__*/_jsx(FilePdfOutlined, {
        style: {
          fontSize: 18
        }
      });

    case 'image':
      return /*#__PURE__*/_jsx(FileImageOutlined, {
        style: {
          fontSize: 18
        }
      });

    case 'doc':
      return /*#__PURE__*/_jsx(FileWordOutlined, {
        style: {
          fontSize: 18
        }
      });

    default:
      return /*#__PURE__*/_jsx(FileOutlined, {
        style: {
          fontSize: 18
        }
      });
  }
};

var formatFileSize = function formatFileSize(size) {
  if (size < 1024) return "".concat(size, " B");
  if (size < 1024 * 1024) return "".concat((size / 1024).toFixed(1), " KB");
  return "".concat((size / (1024 * 1024)).toFixed(1), " MB");
};

export var UploadingFileItem = function UploadingFileItem(_ref2) {
  var file = _ref2.file,
      onRemove = _ref2.onRemove;

  if (!file) {
    return null;
  }

  var variant = getVariantFromMime(file.type);
  var icon = getIconFromVariant(variant);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      $variant: variant,
      children: icon
    }), /*#__PURE__*/_jsxs(FileInfo, {
      children: [/*#__PURE__*/_jsx(FileName, {
        title: file.name,
        children: file.name
      }), /*#__PURE__*/_jsx(FileMeta, {
        children: formatFileSize(file.size)
      })]
    }), /*#__PURE__*/_jsx(RemoveButton, {
      onClick: onRemove,
      type: "button",
      children: /*#__PURE__*/_jsx(CloseOutlined, {
        style: {
          fontSize: 16
        }
      })
    })]
  });
};